import { render } from "./odn-icon-offline.vue?vue&type=template&id=3ccaf492"
const script = {}

import exportComponent from "/oudini/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__